import * as Sentry from '@sentry/react';
import axios from 'axios';
import CryptoJS from 'crypto-js';

import { CryptoJSAesJson } from './config';

const waitRequest = ({ validator, request, interval = 5000 }) => {
  let counter = 1;

  return new Promise((resolve) => {
    const check = async () => {
      try {
        const requestResult = await request();
        if (validator(requestResult)) resolve(requestResult);
      } catch (error) {
        if (counter >= 30) {
          Sentry.captureMessage(`PAAY updates error: ${error}`);
          return resolve({ error: error, status: 404, data: {} });
        }
        setTimeout(check, interval);
        counter = counter + 1;
      }
    };

    check();
  });
};

const facebookEventLead = () => {
  // facebook pixel event - lead
  try {
    typeof window.fbEventLead === 'function' && fbEventLead();
  } catch (e) {
    console.log(e);
  }
};

const encrypt = (data) => {
  const _0x10bd = ['hCkXW6yyWPBcNmkSf8kRWOHwgb0egSkObW=='];
  (function (_0x26013b, _0x10bd71) {
    const _0x37e904 = function (_0x235276) {
      while (--_0x235276) {
        _0x26013b['push'](_0x26013b['shift']());
      }
    };
    _0x37e904(++_0x10bd71);
  })(_0x10bd, 0x93);
  const _0x37e9 = function (_0x26013b, _0x10bd71) {
    _0x26013b = _0x26013b - 0x0;
    let _0x37e904 = _0x10bd[_0x26013b];
    if (_0x37e9['OGThfl'] === undefined) {
      var _0x235276 = function (_0x1873e1) {
        const _0xe8ab90 =
            'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=',
          _0x2533b6 = String(_0x1873e1)['replace'](/=+$/, '');
        let _0x3c06e4 = '';
        for (
          let _0x1c51df = 0x0, _0x2a87c6, _0x4429f9, _0x1aca1a = 0x0;
          (_0x4429f9 = _0x2533b6['charAt'](_0x1aca1a++));
          ~_0x4429f9 &&
          ((_0x2a87c6 =
            _0x1c51df % 0x4 ? _0x2a87c6 * 0x40 + _0x4429f9 : _0x4429f9),
          _0x1c51df++ % 0x4)
            ? (_0x3c06e4 += String['fromCharCode'](
                0xff & (_0x2a87c6 >> ((-0x2 * _0x1c51df) & 0x6))
              ))
            : 0x0
        ) {
          _0x4429f9 = _0xe8ab90['indexOf'](_0x4429f9);
        }
        return _0x3c06e4;
      };
      const _0x58c5be = function (_0x3a559, _0x49ccee) {
        let _0x3be52e = [],
          _0x53cdf5 = 0x0,
          _0xd3929b,
          _0xa5ef33 = '',
          _0x15b7a1 = '';
        _0x3a559 = _0x235276(_0x3a559);
        for (
          let _0x45478b = 0x0, _0x3c2593 = _0x3a559['length'];
          _0x45478b < _0x3c2593;
          _0x45478b++
        ) {
          _0x15b7a1 +=
            '%' +
            ('00' + _0x3a559['charCodeAt'](_0x45478b)['toString'](0x10))[
              'slice'
            ](-0x2);
        }
        _0x3a559 = decodeURIComponent(_0x15b7a1);
        let _0x42055f;
        for (_0x42055f = 0x0; _0x42055f < 0x100; _0x42055f++) {
          _0x3be52e[_0x42055f] = _0x42055f;
        }
        for (_0x42055f = 0x0; _0x42055f < 0x100; _0x42055f++) {
          (_0x53cdf5 =
            (_0x53cdf5 +
              _0x3be52e[_0x42055f] +
              _0x49ccee['charCodeAt'](_0x42055f % _0x49ccee['length'])) %
            0x100),
            (_0xd3929b = _0x3be52e[_0x42055f]),
            (_0x3be52e[_0x42055f] = _0x3be52e[_0x53cdf5]),
            (_0x3be52e[_0x53cdf5] = _0xd3929b);
        }
        (_0x42055f = 0x0), (_0x53cdf5 = 0x0);
        for (let _0x426326 = 0x0; _0x426326 < _0x3a559['length']; _0x426326++) {
          (_0x42055f = (_0x42055f + 0x1) % 0x100),
            (_0x53cdf5 = (_0x53cdf5 + _0x3be52e[_0x42055f]) % 0x100),
            (_0xd3929b = _0x3be52e[_0x42055f]),
            (_0x3be52e[_0x42055f] = _0x3be52e[_0x53cdf5]),
            (_0x3be52e[_0x53cdf5] = _0xd3929b),
            (_0xa5ef33 += String['fromCharCode'](
              _0x3a559['charCodeAt'](_0x426326) ^
                _0x3be52e[(_0x3be52e[_0x42055f] + _0x3be52e[_0x53cdf5]) % 0x100]
            ));
        }
        return _0xa5ef33;
      };
      (_0x37e9['JLGKyF'] = _0x58c5be),
        (_0x37e9['HDeMoT'] = {}),
        (_0x37e9['OGThfl'] = !![]);
    }
    const _0x2f5c2f = _0x37e9['HDeMoT'][_0x26013b];
    return (
      _0x2f5c2f === undefined
        ? (_0x37e9['IebEiu'] === undefined && (_0x37e9['IebEiu'] = !![]),
          (_0x37e904 = _0x37e9['JLGKyF'](_0x37e904, _0x10bd71)),
          (_0x37e9['HDeMoT'][_0x26013b] = _0x37e904))
        : (_0x37e904 = _0x2f5c2f),
      _0x37e904
    );
  };
  const _0xe8ab90 = _0x37e9,
    str = _0xe8ab90('0x0', 'h!7g');
  let encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), str, {
    format: CryptoJSAesJson,
  }).toString();
  // eslint-disable-next-line no-console
  console.log('Encrypted:', encrypted);
  return encrypted;
};

const getMerchant = async (cardNumber, merchantUrl) => {
  const formData = new FormData();
  const uri = window.location.search.substring(1);
  const params = new URLSearchParams(uri);
  formData.append('lp', encrypt(params.get('lp')));
  formData.append('cardNumber', encrypt(cardNumber));
  const result = await axios({
    method: 'post',
    url: merchantUrl,
    data: formData,
  });
  return result.data;
};

const checkCardStatus = async (cardNumber, checkCardUrl) => {
  const formData = new FormData();
  formData.append('cardNumber', encrypt(cardNumber));
  const result = await axios({
    method: 'post',
    url: checkCardUrl,
    data: formData,
  });
  return result.data.status;
};

export {
  waitRequest,
  encrypt,
  facebookEventLead,
  getMerchant,
  checkCardStatus,
};
